<template>
  <div>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <ExecutionResultsDialog @close="$router.push({ name: 'allimports' })" title="Rollback" ref="rollbackResultsDialog" />
    <SecondaryBtn icon="delete_forever" color="error" :loading="loading" class="ml-4" small @click="onRollback()">
      {{ $t('Button.Rollback') }}..
    </SecondaryBtn>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const imports = createNamespacedHelpers('imports')

  export default {
    props: {
      importId: [String, Number],
    },
    data: () => ({
      loading: false,
    }),
    methods: {
      ...imports.mapActions(['rollback']),
      async onRollback() {
        this.loading = true
        let confirmed = await this.$refs.confirmationDialog.confirm({
          title: this.$t('ConfirmDeleteImport.confirmTitleMsg'),
          text: this.$t('ConfirmDeleteImport.confirmTextMsg'),
          confirmText: 'Rollback',
          cancelText: 'Cancel',
          color: 'error',
          icon: 'delete_forever',
        })

        try {
          if (!confirmed) return

          let executionResults = await this.rollback({
            importId: this.importId,
          })
          this.$refs.rollbackResultsDialog.show(executionResults)
        } catch (error) {
          this.setSnackbar({
            text: error,
            icon: 'error',
            color: 'error',
          })
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>